/**
 * Libraries
 */

import { defineStore } from 'pinia';

/**
 * Types
 */

import {
  type Message,
  type ToasterMessage,
} from '@core/types/ToasterMessageTypes';

const TOASTER_MESSAGE_STORE_ID = 'toasterMessage';

const useToasterMessageStore = defineStore(TOASTER_MESSAGE_STORE_ID, {
  state: (): ToasterMessage => ({
    messages: [],
  }),

  getters: {
    messageByTitle: (state: ToasterMessage) => {
      return (title: string) =>
        state.messages.find((message: Message) => message.title === title);
    },
  },

  actions: {
    addNewMessage(message: Message) {
      this.messages.push(message);
    },
    removeMessage(message: Message) {
      const index = this.messages.findIndex(
        (item) => item.title === message.title,
      );
      if (index !== -1) this.messages.splice(index, 1);
    },
  },
});

export { useToasterMessageStore };
